import { UseFormReturn } from 'react-hook-form'
import { useEffect } from 'react'
import { Company } from '@models/company'
import { Filial } from '@models/filial'
import { Division } from '@models/division'
import type { JobFieldNames } from './useJobDataForFields'

const useJobCleaner = ({
  watch,
  setValue,
  formState: { isDirty },
}: UseFormReturn, fieldNames: JobFieldNames): void => {
  const company: Company | undefined = watch(fieldNames.company)
  const filial: Filial | undefined = watch(fieldNames.filial)
  const division: Division | undefined = watch(fieldNames.division)

  useEffect(() => {
    if (isDirty) {
      setValue(fieldNames.filial, null)
      setValue(fieldNames.division, null)
      setValue(fieldNames.position, null)
    }
  }, [company?.id])

  useEffect(() => {
    if (isDirty) {
      setValue(fieldNames.division, null)
      setValue(fieldNames.position, null)
    }
  }, [filial?.id])

  useEffect(() => {
    if (isDirty) {
      setValue(fieldNames.position, null)
    }
  }, [division?.id])
}

export default useJobCleaner
